module.exports = __webpack_public_path__ + "static/media/bagy14.bdf450b6.png";